export default __webpack_public_path__ + "src/assets/expand-default.524eb9cd89602f0caf0dbdbf78effd15.svg";